export default function conditionReducer(conditions, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "hour": {
      const _conditions = Object.assign({}, conditions);
      const days = action.position === "week" ? ["mon", "tue", "wed", "thu", "fri"] : ["sat", "sun"];
      const hourPosition = action.hour * 4;

      for (let dayInt = 0; dayInt < days.length; dayInt++) {
        _conditions[days[dayInt]].fill(Number(action.destination?.id || 0), hourPosition, hourPosition + 4);
      }

      return _conditions;
    }
    case "day": {
      return {
        ...conditions,
        [action.day]: [...conditions[action.day].fill(Number(action.destination?.id || 0), 0)],
      };
    }
    case "selection": {
      const _conditions = Object.assign({}, conditions);

      action.selection.map(
        (item) => (_conditions[item.props.day][item.props.place] = Number(action.destination?.id || 0)),
      );

      return _conditions;
    }

    default:
      return { ...conditions, [action.type]: action.value };
  }
}
